import { EndpointPermissionRule } from '../core/permissions/endpoint-permission.models';

import { P } from './portal-permissions.constants';

const SIRKETLER = P.UygulamaYonetimi.Sirketler;

const ENTEGRASYONLAR = P.UygulamaYonetimi.Entegrasyonlar;

function multiRead(
  pattern: string,

  permissionKeys: string[],

  methods: ('GET' | 'POST' | 'PUT' | 'DELETE')[] = ['GET', 'POST'],
): EndpointPermissionRule[] {
  return methods.map((method) => ({
    method,

    pattern,

    permissionKeys,

    access: 'read' as const,
  }));
}

function multiWrite(
  pattern: string,

  permissionKeys: string[],

  methods: ('GET' | 'POST' | 'PUT' | 'DELETE')[] = ['POST'],
): EndpointPermissionRule[] {
  return methods.map((method) => ({
    method,

    pattern,

    permissionKeys,

    access: 'write' as const,
  }));
}

/** Uygulama Yönetimi — şirketler + entegrasyonlar (ApplicationAdmin alanı). */

export const UYGULAMA_YONETIMI_ENDPOINT_EXTRA_RULES: readonly EndpointPermissionRule[] =
  [
    ...multiRead(
      'api/Application/GetAllApplication',
      [SIRKETLER, P.Yonetim.Kullanicilar],
      ['GET'],
    ),

    ...multiWrite('api/Application/CreateApplication', [SIRKETLER]),

    ...multiWrite('api/Application/UpdateApplication', [SIRKETLER]),

    // LDAP ayarları yönetimi (SuperAdmin ekranı; backend: LdapSettingsController → UygulamaYonetimi.Sirketler)
    ...multiRead('api/LdapSettings', [SIRKETLER], ['GET']),

    ...multiWrite('api/LdapSettings', [SIRKETLER], ['POST', 'PUT', 'DELETE']),

    ...multiWrite('api/LdapSettings/test', [SIRKETLER]),

    ...multiRead('api/LdapSettings/companies', [SIRKETLER], ['GET']),

    ...multiRead(
      'api/Company/GetCompanyDetailForApplication',
      [SIRKETLER],
      ['GET'],
    ),

    ...multiWrite('api/Company/CreateCompany', [SIRKETLER]),

    ...multiWrite('api/Company/UpdateCompany', [SIRKETLER]),

    ...multiWrite('api/Company/DeleteCompany', [SIRKETLER]),

    ...multiWrite('api/Company/RenameCountry', [
      SIRKETLER,

      P.EmisyonFaktorleri.OtelKonaklama,
    ]),

    ...multiWrite('api/Company/RenameCity', [
      SIRKETLER,

      P.EmisyonFaktorleri.OtelKonaklama,
    ]),

    ...multiRead('api/Company/GetSegments', [SIRKETLER], ['GET']),

    ...multiRead('api/Company/GetNaceCodes', [SIRKETLER], ['GET']),

    ...multiRead('api/Company/GetCountries', [SIRKETLER], ['GET']),

    ...multiRead(
      'api/Company/GetCountriesFromEnergyEfficiency',
      [SIRKETLER],
      ['GET'],
    ),

    ...multiRead('api/Company/GetCities', [SIRKETLER]),

    // Integration client form: company selector + integration service-user selector.
    ...multiRead('api/Company/GetCompanies', [SIRKETLER, ENTEGRASYONLAR]),
    ...multiRead('api/Identity/GetAllUsers', [SIRKETLER, ENTEGRASYONLAR]),

    ...multiRead('api/IntegrationManagement/Scopes', [ENTEGRASYONLAR], ['GET']),

    ...multiRead(
      'api/IntegrationManagement/Clients',
      [ENTEGRASYONLAR],
      ['GET'],
    ),

    ...multiWrite(
      'api/IntegrationManagement/Clients',
      [ENTEGRASYONLAR],
      ['POST', 'PUT', 'DELETE'],
    ),

    ...multiRead('api/Integration/Health', [ENTEGRASYONLAR], ['GET']),

    ...multiRead(
      'api/Integration/EmissionCategories',
      [ENTEGRASYONLAR],
      ['GET'],
    ),

    ...multiRead('api/Integration/EmissionSources', [ENTEGRASYONLAR], ['GET']),
  ];
